import * as PIXI from "pixi.js";
import { ColorSource } from "pixi.js";
import { Game } from "./Game";

export class DebugShade {
	public readonly graphics: PIXI.Graphics = new PIXI.Graphics;
	private _size: number = 30;
	private _color: ColorSource = 0;
	private _alpha: number = 0.2;

	public constructor() {
		this.graphics.circle(0, 0, 30);
		this.graphics.fill({r: 255, g: 255, b: 255, a: 255});

		this.graphics.alpha = this._alpha;
		this.graphics.tint = {r: 0, g: 0, b: 0};
		this.graphics.zIndex = -1;
	}

	public set size(value: number) {
		if (this._size != value) {
			this._size = value;
			this.graphics.scale = {x: value / 30, y: value / 30};
		}
	}

	public set color(value: ColorSource) {
		if (this._color != value) {
			this._color = value;
			this.graphics.tint = this._color;
		}
	}

	public set alpha(value: number) {
		if (this._alpha != value) {
			this._alpha = value;
			this.graphics.alpha = this._alpha;
		}
	}
}
